module.exports = __webpack_public_path__ + "static/img/1.27f814a2.jpg";